import { getSurfaceStore } from 'owa-calendar-surface-surface-store';
import { DateRange } from 'owa-datetime-utils';

/**
 * Datapoints to capture custom data for calendar-surface actions
 */
export default {
    UpdateDateRange: {
        name: 'UpdateDateRange',
        customData: (newDateRange: DateRange): any => {
            const surfaceStore = getSurfaceStore();
            return {
                CurrentDateRangeType: surfaceStore.dateRangeType,
                SplitMode: surfaceStore.isInSplitView,
            };
        },
        options: {
            isCore: true,
        },
    },
};
